
namespace GeniuzPOS.InitialData {

    @Serenity.Decorators.registerClass()
    export class PsCustomerSurveyGrid extends Serenity.EntityGrid<PsCustomerSurveyRow, any> {
        protected getColumnsKey() { return PsCustomerSurveyColumns.columnsKey; }
        protected getDialogType() { return PsCustomerSurveyDialog; }
        protected getIdProperty() { return PsCustomerSurveyRow.idProperty; }
        protected getInsertPermission() { return PsCustomerSurveyRow.insertPermission; }
        protected getLocalTextPrefix() { return PsCustomerSurveyRow.localTextPrefix; }
        protected getService() { return PsCustomerSurveyService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}